(function () {
  'use strict';

  var BAG_KEY = 'dv_native_review_bag_v1';
  var realMode = window.DV_COMMERCE_EFFECTIVE_MODE === 'test' || window.DV_COMMERCE_EFFECTIVE_MODE === 'live';
  var catalog = window.DV_NATIVE_CATALOG || {};
  var products = Array.isArray(catalog.products) ? catalog.products : [];
  var accessories = catalog.accessories || {};
  var chains = Array.isArray(catalog.chainOptions) ? catalog.chainOptions : [];
  var platedChains = Array.isArray(catalog.platedChainOptions) ? catalog.platedChainOptions : [];
  var stoneLabels = catalog.stoneLabels || {};
  var materialLabels = catalog.materialLabels || { silver: 'Sterling Silver', plated: 'Gold Plated', solid: 'Solid 14K Gold' };
  var gallery = catalog.gallery || {};
  var goldAssets = catalog.goldAssets || {};
  var exactSetImages = {
    'daisy:sapphire:rolo-necklace': {
      src: 'https://cdn.shopify.com/s/files/1/0948/2030/3131/files/pdp-daisy-day-set-lifestyle__MP_09332.jpg?v=1784062405',
      label: 'Daisy Day sapphire + Rolo Necklace'
    },
    'endless:sapphire:rolo-necklace': {
      src: 'https://cdn.shopify.com/s/files/1/0948/2030/3131/files/pdp-endless-set-lifestyle__MP_09357.jpg?v=1784062410',
      label: 'Endless sapphire + Rolo Necklace'
    },
    'paw:white:rolo-bracelet': {
      src: 'https://cdn.shopify.com/s/files/1/0948/2030/3131/files/paw-promise-bracelet-set-main-wider-zoomout-v3.jpg?v=1784200778',
      label: 'Paw Promise white diamond + Rolo Bracelet'
    }
  };
  var lastIntercept = { key: '', time: 0 };
  var focusReturn = null;

  function escapeHTML(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function money(value) {
    var amount = Number(value) || 0;
    return new Intl.NumberFormat('en-US', {
      style: 'currency', currency: 'USD',
      minimumFractionDigits: Math.round(amount * 100) % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    }).format(amount);
  }

  function safeImage(value) {
    var image = String(value || '');
    return /^(?:https?:)?\/\//i.test(image) || image.charAt(0) === '/' ? image : '';
  }

  function cleanItem(input) {
    input = input || {};
    var price = Number(input.price);
    var quantity = Math.max(1, Math.min(99, Math.trunc(Number(input.quantity != null ? input.quantity : input.qty) || 1)));
    if (!Number.isFinite(price) || price < 0 || price > 100000) return null;
    var title = String(input.title || input.name || 'DIVETIA piece').slice(0, 180);
    var material = String(input.material || '').slice(0, 80);
    var stone = String(input.stone || '').slice(0, 100);
    var chain = String(input.chain || '').slice(0, 100);
    var key = String(input.key || [input.variantId || input.id || title, material, stone, chain].join(':')).slice(0, 300);
    return {
      key: key,
      title: title,
      material: material,
      stone: stone,
      chain: chain,
      variant: String(input.variant || '').slice(0, 100),
      variantId: Number(input.variantId || input.id) || null,
      price: price,
      compareAt: Number(input.compareAt) > price ? Number(input.compareAt) : null,
      quantity: quantity,
      image: safeImage(input.image),
      url: String(input.url || '').slice(0, 500),
      fulfillment: String(input.fulfillment || '').slice(0, 240),
      mode: input.mode === 'waitlist' ? 'waitlist' : 'cart',
      pairKey: String(input.pairKey || '').slice(0, 300),
      pairRole: input.pairRole === 'charm' || input.pairRole === 'chain' ? input.pairRole : '',
      pairedPrice: Number(input.pairedPrice) || null,
      standalonePrice: Number(input.standalonePrice) || null,
      components: Array.isArray(input.components) ? input.components.slice(0, 4) : []
    };
  }

  function currentSolidGoldItem(item) {
    if (!/solid\s*14k/i.test(item.material) || item.mode !== 'cart') return item;
    var parts = item.components || [];
    if (parts.length !== 1 || parts[0].role !== 'charm') return item;
    var product = products.find(function (entry) { return item.title === entry.name + ' Charm' || item.title === entry.name; });
    if (!product || !Number.isFinite(Number(product.solid))) return item;
    var part = Object.assign({}, parts[0]);
    if ('price' in part) part.price = Number(product.solid);
    return Object.assign({}, item, { price: Number(product.solid), compareAt: null, components: [part], fulfillment: 'Made for you · Ships within 2–3 weeks', variant: /Production, cancellation and return terms pending confirmation/.test(item.variant) ? 'Made to order' : item.variant });
  }

  // Refresh the three approved silver relaunch prices in previously saved preview bags.
  function currentSilverItem(item) {
    if (!/silver/i.test(item.material) || /gold/i.test(item.material) || item.mode !== 'cart') return item;
    var targetStones = { endless: 'sapphire', flutter: 'pink', blossom: 'pink' };
    var parts = item.components || [];
    var charm = parts.find(function (part) { return part.role === 'charm'; });
    var product = products.find(function (entry) {
      var stone = targetStones[entry.id];
      if (!stone || item.stone !== stoneLabels[stone]) return false;
      var nativeId = Number(entry.native && entry.native[stone] && entry.native[stone][0]);
      return Number(item.variantId) === nativeId || (charm && Number(charm.id || charm.variantId) === nativeId) ||
        item.title === entry.name || item.title.indexOf(entry.name + ' ') === 0 || (charm && charm.title === entry.name + ' Charm');
    });
    if (!product) return item;
    var pair = product.silver[targetStones[product.id]];
    var chainPrice = parts.filter(function (part) { return part.role === 'chain'; }).reduce(function (sum, part) { return sum + Number(part.price || 0); }, 0);
    var oldPrice = charm && Number.isFinite(Number(charm.price)) ? Number(charm.price) :
      charm && Number.isFinite(Number(charm.standalonePrice)) ? Number(charm.standalonePrice) : item.price - chainPrice;
    if (oldPrice !== 399 && oldPrice !== Number(pair[0])) return item;
    var updatedParts = parts.map(function (part) {
      if (part !== charm) return part;
      var updated = Object.assign({}, part);
      ['price', 'standalonePrice', 'pairedPrice'].forEach(function (key) { if (key in updated) updated[key] = Number(pair[0]); });
      return updated;
    });
    return Object.assign({}, item, { price: item.price - oldPrice + Number(pair[0]), components: updatedParts });
  }

  function readBag() {
    try {
      var raw = JSON.parse(localStorage.getItem(BAG_KEY) || '[]');
      return Array.isArray(raw) ? repriceOriginalBuilder(repricePdpPairs(splitPairedItems(raw.map(cleanItem).filter(Boolean).filter(function (item) { return !/gold[\s-]*plated/i.test(item.material); }).map(currentSolidGoldItem).map(currentSilverItem)))).slice(0, 50) : [];
    } catch (_) { return []; }
  }

  function cartTriggers() {
    return document.querySelectorAll([
      'a[href="/cart"]',
      'a[href^="/cart?"]',
      'a[data-cart-icon]',
      'button[data-cart-icon]',
      'a[data-open-cart]',
      'button[data-open-cart]',
      'a[data-dv-native-open-bag]',
      'button[data-dv-native-open-bag]'
    ].join(','));
  }

  function mountCartIndicators() {
    cartTriggers().forEach(function (trigger) {
      if (trigger.querySelector('[data-dv-cart-indicator]')) return;
      trigger.classList.add('dv-native-cart-indicator-host');
      var indicator = document.createElement('span');
      indicator.className = 'dv-native-cart-indicator';
      indicator.hidden = true;
      indicator.setAttribute('data-dv-cart-indicator', '');
      indicator.setAttribute('aria-hidden', 'true');
      trigger.appendChild(indicator);
    });
  }

  function syncCartIndicatorVisibility(items) {
    mountCartIndicators();
    var hasItems = quantity(items || readBag()) > 0;
    document.querySelectorAll('[data-dv-cart-indicator]').forEach(function (indicator) {
      indicator.hidden = !hasItems;
      indicator.classList.toggle('dv-native-cart-indicator--pulse', hasItems);
    });
    return hasItems;
  }

  function updateCartIndicators(items) {
    // Presence drives the pulse, including reloads, navigation and cross-tab sync.
    // CSS keeps the dot static when reduced motion is requested.
    syncCartIndicatorVisibility(items);
  }

  // Keep the original-builder review bag honest when pieces are removed or
  // quantities change: one paired-chain saving per selected charm. Allocate
  // necklaces first, then bracelets, to preserve maximum savings at 10%.
  function repriceOriginalBuilder(items) {
    var budget = 0;
    var groups = {};
    items.forEach(function (item) {
      var component = item.components && item.components[0];
      if (!item.key.startsWith('original-builder-preview:') || !component || !component.previewOnly) return;
      if (component.role === 'charm' && (/silver/i.test(item.material) && !/gold/i.test(item.material))) budget += item.quantity;
      var standalone = Number(component.standalonePrice);
      var paired = Number(component.pairedPrice);
      var knownNecklace = component.kind === 'necklace' && standalone === 149 && (paired === 134.1 || paired === 129 || paired === 149);
      var legacyBracelet = component.kind === 'bracelet' && standalone === 99 && paired === 99;
      var knownBracelet = component.kind === 'bracelet' && standalone === 99 && (paired === 89.1 || paired === 89 || legacyBracelet);
      if (component.role === 'chain' && (/silver/i.test(item.material) && !/gold/i.test(item.material)) && (knownNecklace || knownBracelet)) {
        var groupKey = component.kind + ':' + String(component.variantId);
        var normalizedComponent = Object.assign({}, component, { pairedPrice: knownNecklace ? 134.1 : 89.1 });
        var normalizedItem = Object.assign({}, item, { components: [normalizedComponent].concat(item.components.slice(1)) });
        if (!groups[groupKey]) groups[groupKey] = { item: normalizedItem, quantity: 0, component: normalizedComponent, discounted: 0 };
        groups[groupKey].quantity += item.quantity;
      }
    });
    ['necklace', 'bracelet'].forEach(function (kind) {
      Object.keys(groups).forEach(function (groupKey) {
        var group = groups[groupKey];
        if (group.component.kind !== kind || budget <= 0) return;
        group.discounted = Math.min(group.quantity, budget);
        budget -= group.discounted;
      });
    });
    var emitted = {};
    var output = [];
    items.forEach(function (item) {
      var component = item.components && item.components[0];
      var id = component && String(component.variantId);
      var groupKey = component && component.kind + ':' + id;
      if (item.key.startsWith('original-builder-preview:') && component && component.role === 'chain' &&
        (!/silver/i.test(item.material) || /gold/i.test(item.material))) {
        var standalonePrice = Number(component.standalonePrice);
        output.push(Number.isFinite(standalonePrice) ? Object.assign({}, item, {
          price: standalonePrice,
          components: [Object.assign({}, component, { pairedPrice: standalonePrice })].concat(item.components.slice(1))
        }) : item);
        return;
      }
      if (!item.key.startsWith('original-builder-preview:') || !component || component.role !== 'chain' || !groups[groupKey]) {
        output.push(item);
        return;
      }
      if (emitted[groupKey]) return;
      emitted[groupKey] = true;
      var group = groups[groupKey];
      var groupStandalone = Number(group.component.standalonePrice);
      var groupPaired = Number(group.component.pairedPrice);
      if (group.discounted) output.push(Object.assign({}, group.item, { key: 'original-builder-preview:' + id + ':paired', quantity: group.discounted, price: groupPaired }));
      if (group.quantity > group.discounted) output.push(Object.assign({}, group.item, { key: 'original-builder-preview:' + id + ':standalone', quantity: group.quantity - group.discounted, price: groupStandalone }));
    });
    return output;
  }

  // Migrate earlier combined PDP review lines and keep each visible piece editable.
  function splitPairedItems(items) {
    return items.reduce(function (output, item) {
      var parts = item.components || [];
      var charm = parts.find(function (part) { return part.role === 'charm'; });
      var chain = parts.find(function (part) { return part.role === 'chain'; });
      if (item.mode !== 'cart' || item.pairKey || !charm || !chain || !/Charm/i.test(item.title)) {
        output.push(item);
        return output;
      }
      var accessory = Object.keys(accessories).map(function (key) { return accessories[key]; }).find(function (entry) {
        return Number(entry.native && entry.native[0]) === Number(chain.variantId || chain.id) ||
          entry.name === item.chain || entry.name.replace(/^The /, '') === item.chain || entry.name === chain.title;
      });
      var option = chains.find(function (entry) { return accessory && entry.id === accessory.id; });
      var pairedPrice = option ? Number(option.price) : Number(chain.price);
      var standalonePrice = option ? Number(option.standalonePrice) : Number(accessory && accessory.price);
      var charmPrice = Number(charm.price);
      if (!Number.isFinite(charmPrice)) charmPrice = item.price - Number(chain.price || 0);
      var pairKey = item.key;
      output.push(Object.assign({}, item, {
        key: pairKey + ':charm', title: charm.title || item.title.replace(/\s*\+.*$/, ''), chain: '', price: charmPrice,
        pairKey: pairKey, pairRole: 'charm', components: [charm]
      }));
      output.push(Object.assign({}, item, {
        key: pairKey + ':chain:paired', title: accessory && accessory.name || chain.title || item.chain,
        material: item.material, stone: '', chain: '', variant: '',
        variantId: Number(accessory && accessory.native && accessory.native[0]) || Number(chain.id) || null,
        price: pairedPrice, compareAt: null, image: safeImage(accessory && accessory.image),
        pairKey: pairKey, pairRole: 'chain', pairedPrice: pairedPrice,
        standalonePrice: Number.isFinite(standalonePrice) ? standalonePrice : pairedPrice,
        components: [chain]
      }));
      return output;
    }, []);
  }

  function repricePdpPairs(items) {
    var groups = {};
    items.forEach(function (item) {
      if (!item.pairKey) return;
      if (!groups[item.pairKey]) groups[item.pairKey] = { charms: 0, chains: 0, chain: null };
      var group = groups[item.pairKey];
      if (item.pairRole === 'charm') group.charms += item.quantity;
      if (item.pairRole === 'chain') { group.chains += item.quantity; group.chain = group.chain || item; }
    });
    var emitted = {};
    return items.reduce(function (output, item) {
      if (!item.pairKey || item.pairRole !== 'chain') { output.push(item); return output; }
      if (emitted[item.pairKey]) return output;
      emitted[item.pairKey] = true;
      var group = groups[item.pairKey];
      var chain = group.chain;
      var paired = Math.min(group.charms, group.chains);
      var standalone = group.chains - paired;
      if (paired) output.push(Object.assign({}, chain, { key: item.pairKey + ':chain:paired', quantity: paired, price: chain.pairedPrice || chain.price }));
      if (standalone) output.push(Object.assign({}, chain, { key: item.pairKey + ':chain:standalone', quantity: standalone, price: chain.standalonePrice || chain.price }));
      return output;
    }, []);
  }

  function writeBag(items, options) {
    var clean = repriceOriginalBuilder(repricePdpPairs(splitPairedItems(items.map(cleanItem).filter(Boolean).map(currentSolidGoldItem).map(currentSilverItem)))).slice(0, 50);
    try { localStorage.setItem(BAG_KEY, JSON.stringify(clean)); } catch (_) {}
    updateCounts(clean);
    updateCartIndicators(clean, Boolean(options && options.pulse));
    window.dispatchEvent(new CustomEvent('dv:native:bag-changed', { detail: { items: clean } }));
    return clean;
  }

  function quantity(items) {
    return items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
  }

  function subtotal(items) {
    return items.reduce(function (sum, item) { return sum + item.price * item.quantity; }, 0);
  }

  function updateCounts(items) {
    var count = realMode ? window.DVRealCommerce.count() : quantity(items || readBag());
    document.querySelectorAll('.sf-cart-count, [data-dv-native-bag-count]').forEach(function (node) {
      node.textContent = String(count);
      node.setAttribute('aria-label', count + (realMode ? (count === 1 ? ' item in bag' : ' items in bag') :
        (count === 1 ? ' item in review bag' : ' items in review bag')));
    });
    if (realMode) syncCartIndicatorVisibility(Array(count).fill({ quantity: 1 }));
    else syncCartIndicatorVisibility(items);
  }

  function meta(item) {
    var variant = item.variant && item.stone && String(item.stone).toLowerCase().indexOf(String(item.variant).toLowerCase()) !== -1 ? '' : item.variant;
    return [item.material, item.stone, item.chain, variant].filter(Boolean).join(' · ');
  }

  function lineHTML(item, index) {
    return '<article class="dv-native-line" data-dv-native-line="' + index + '">' +
      '<div class="dv-native-line__image">' + (item.image ? '<img src="' + escapeHTML(item.image) + '" alt="">' : '') + '</div>' +
      '<div><div class="dv-native-line__top"><h3 class="dv-native-line__title">' + escapeHTML(item.title) + '</h3><strong>' + money(item.price * item.quantity) + '</strong></div>' +
      '<p class="dv-native-line__meta">' + escapeHTML(meta(item) || item.fulfillment || 'Review selection') + '</p>' +
      (item.pairRole === 'chain' && item.pairedPrice && item.price === item.pairedPrice && item.standalonePrice > item.pairedPrice ? '<p class="dv-native-line__offer">10% off with charm</p>' : '') +
      (item.fulfillment && /solid\s*14k/i.test(item.material) && meta(item) ? '<p class="dv-native-line__meta" data-dv-fulfillment>' + escapeHTML(item.fulfillment) + '</p>' : '') +
      '<div class="dv-native-line__controls"><div class="dv-native-line__qty" aria-label="Quantity for ' + escapeHTML(item.title) + '">' +
      '<button type="button" data-dv-native-qty="-1" aria-label="Decrease quantity">−</button><output>' + item.quantity + '</output><button type="button" data-dv-native-qty="1" aria-label="Increase quantity">+</button></div>' +
      '<button type="button" class="dv-native-line__remove" data-dv-native-remove>Remove</button></div></div></article>';
  }

  function bagContents(items) {
    if (!items.length) return '<div class="dv-native-bag__empty"><p>Your review bag is empty.</p><a href="/collections/all">Explore the collection</a></div>';
    return items.map(lineHTML).join('');
  }

  function mountBag() {
    if (document.querySelector('[data-dv-native-bag]')) return;
    var root = document.createElement('div');
    root.className = 'dv-native-bag';
    root.hidden = true;
    root.setAttribute('data-dv-native-bag', '');
    root.innerHTML = '<div class="dv-native-bag__shade" data-dv-native-close></div><aside class="dv-native-bag__panel" role="dialog" aria-modal="true" aria-labelledby="dv-native-bag-title">' +
      '<header class="dv-native-bag__header"><div class="dv-native-bag__header-row"><h2 class="dv-native-bag__title" id="dv-native-bag-title">Your Bag</h2><button type="button" class="dv-native-bag__close" data-dv-native-close aria-label="Close bag">×</button></div></header>' +
      '<div class="dv-native-bag__body" data-dv-native-lines></div>' +
      '<footer class="dv-native-bag__footer"><div class="dv-native-bag__subtotal"><span>Subtotal</span><strong data-dv-native-subtotal></strong></div><p class="dv-native-bag__shipping">Insured shipping from $12.95, chosen at checkout. Taxes calculated at checkout.</p><button type="button" class="dv-native-bag__button" data-dv-native-checkout>Checkout</button></footer></aside>';
    document.body.appendChild(root);
    root.addEventListener('click', handleBagClick);
  }

  function renderBag() {
    mountBag();
    if (realMode) {
      window.DVRealCommerce.render(document.querySelector('[data-dv-native-bag]'));
      updateCounts();
      return;
    }
    var items = readBag();
    var root = document.querySelector('[data-dv-native-bag]');
    root.querySelector('[data-dv-native-lines]').innerHTML = bagContents(items);
    root.querySelector('[data-dv-native-subtotal]').textContent = money(subtotal(items));
    root.querySelector('.dv-native-bag__footer').hidden = !items.length;
    updateCounts(items);
  }

  function openBag() {
    focusReturn = document.activeElement;
    renderBag();
    var root = document.querySelector('[data-dv-native-bag]');
    root.hidden = false;
    document.documentElement.classList.add('dv-native-bag-open');
    root.querySelector('.dv-native-bag__close').focus();
    if (realMode) window.DVRealCommerce.refresh().catch(function (error) { showModal('Bag unavailable', '<p>' + escapeHTML(error.message) + '</p>'); });
  }

  function closeBag() {
    var root = document.querySelector('[data-dv-native-bag]');
    if (!root) return;
    root.hidden = true;
    document.documentElement.classList.remove('dv-native-bag-open');
    if (focusReturn && focusReturn.focus) focusReturn.focus();
  }

  function mutateLine(index, delta, remove) {
    if (realMode) {
      var current = window.DVRealCommerce.getCart();
      var line = current && current.items && current.items[index];
      if (!line) return;
      var controls = document.querySelectorAll('[data-dv-native-qty], [data-dv-native-remove]');
      controls.forEach(function (control) { control.disabled = true; });
      window.DVRealCommerce.change(index, remove ? 0 : Math.max(0, line.quantity + delta)).catch(function (error) {
        showModal('Could not update bag', '<p>' + escapeHTML(error.message) + '</p>');
      }).finally(function () {
        controls.forEach(function (control) { if (control.isConnected) control.disabled = false; });
      });
      return;
    }
    var items = readBag();
    if (!items[index]) return;
    if (remove) items.splice(index, 1);
    else {
      items[index].quantity += delta;
      if (items[index].quantity <= 0) items.splice(index, 1);
    }
    writeBag(items, { pulse: delta > 0 });
    renderBag();
    renderCartPage();
  }

  function handleBagClick(event) {
    var close = event.target.closest('[data-dv-native-close]');
    if (close) return closeBag();
    var line = event.target.closest('[data-dv-native-line]');
    if (line && event.target.closest('[data-dv-native-remove]')) return mutateLine(Number(line.dataset.dvNativeLine), 0, true);
    var qty = event.target.closest('[data-dv-native-qty]');
    if (line && qty) return mutateLine(Number(line.dataset.dvNativeLine), Number(qty.dataset.dvNativeQty), false);
    if (event.target.closest('[data-dv-native-checkout]')) {
      if (realMode) window.DVRealCommerce.checkout();
      else openCheckoutReview();
    }
  }

  function ensureModal() {
    var modal = document.querySelector('[data-dv-native-modal]');
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'dv-native-modal';
    modal.hidden = true;
    modal.setAttribute('data-dv-native-modal', '');
    modal.innerHTML = '<section class="dv-native-modal__card" role="dialog" aria-modal="true" aria-labelledby="dv-native-modal-title"><span class="dv-native-review-label">' + (realMode ? 'DIVETIA' : 'Unpublished review') + '</span><h2 id="dv-native-modal-title" data-dv-native-modal-title>Review only</h2><div data-dv-native-modal-copy></div><button type="button" class="dv-native-modal__button" data-dv-native-modal-close>Close</button></section>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.closest('[data-dv-native-modal-close]')) closeModal();
    });
    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { event.preventDefault(); closeModal(); return; }
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])')).filter(function (node) {
        return !node.closest('[hidden]');
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    return modal;
  }

  function closeModal() {
    var modal = document.querySelector('[data-dv-native-modal]');
    if (!modal) return;
    modal.querySelectorAll('input[type="email"]').forEach(function (input) { input.value = ''; });
    modal.hidden = true;
    document.documentElement.classList.remove('dv-native-bag-open');
    if (focusReturn && focusReturn.focus) focusReturn.focus();
  }

  function showModal(title, copy) {
    focusReturn = document.activeElement;
    var modal = ensureModal();
    modal.classList.remove('dv-native-modal--waitlist', 'dv-native-modal--success');
    modal.querySelector('[data-dv-native-modal-title]').textContent = title;
    modal.querySelector('[data-dv-native-modal-copy]').innerHTML = copy;
    modal.hidden = false;
    document.documentElement.classList.add('dv-native-bag-open');
    modal.querySelector('[data-dv-native-modal-close]').focus();
  }

  function openCheckoutReview() {
    var items = readBag();
    if (!items.length) return openBag();
    var total = subtotal(items);
    var lines = items.map(function (item) {
      return '<li><span>' + item.quantity + ' × ' + escapeHTML(item.title) + '</span> — <strong>' + money(item.price * item.quantity) + '</strong></li>';
    }).join('');
    closeBag();
    showModal('Checkout unavailable in preview', '<ul>' + lines + '</ul><p>Subtotal: <strong>' + money(total) + '</strong><br>Insured shipping from $12.95, chosen at checkout. Taxes calculated at checkout.</p><p>This private preview stops before Shopify checkout. Nothing was charged or ordered.</p>');
  }

  function showWaitlist(item) {
    closeBag();
    var product = products.find(function (entry) { return String(item.title || '').indexOf(entry.name) !== -1; });
    var image = safeImage(item.image || (product && goldAssets[product.id]));
    var name = String(item.title || 'DIVETIA piece').replace(/\s*\+.*$/, '');
    var copy = '<div class="dv-native-modal__product">' +
      (image ? '<img src="' + escapeHTML(image) + '" alt="" loading="lazy">' : '') +
      '<div><strong>' + escapeHTML(name) + '</strong><span>Gold plated · ' + money(item.price) + ' (expected)</span></div></div>' +
      '<p class="dv-native-modal__intro">We\'ll email you when gold-plated ' + escapeHTML(name) + ' is ready to order.</p>' +
      '<div data-dv-native-waitlist-form><label class="dv-native-modal__label" for="dv-native-waitlist-email">Email address</label>' +
      '<input class="dv-native-modal__input" id="dv-native-waitlist-email" data-dv-native-waitlist-email type="email" autocomplete="email" required placeholder="you@example.com">' +
      '<button type="button" class="dv-native-modal__button" data-dv-native-waitlist-submit>Notify me</button>' +
      '<p class="dv-native-modal__consent" data-dv-waitlist-consent>By signing up you agree to receive emails from DIVETIA. Unsubscribe anytime. <a href="/policies/privacy-policy">Privacy Policy</a></p></div>' +
      '<p class="dv-native-modal__status" data-dv-native-waitlist-status role="status"></p>';
    showModal('Be the first to know', copy);
    var modal = ensureModal();
    modal.classList.add('dv-native-modal--waitlist');
    var input = modal.querySelector('[data-dv-native-waitlist-email]');
    var button = modal.querySelector('[data-dv-native-waitlist-submit]');
    button.addEventListener('click', function () {
      if (!input.checkValidity()) {
        input.reportValidity();
        return;
      }
      if (window.DV_COMMERCE_EFFECTIVE_MODE !== 'live') {
        modal.querySelector('[data-dv-native-waitlist-status]').textContent = 'Preview only. Nothing was submitted.';
        return;
      }
      var payload = { email: input.value, design: item.design || item.title, material: 'plated', item: item.item || item.title,
        displayedPrice: Number(item.displayedPrice != null ? item.displayedPrice : item.price), sourceUrl: location.href };
      Promise.resolve(window.DV_WAITLIST.submit(payload)).then(function (result) {
        input.value = '';
        if (result && result.submitted) {
          modal.classList.add('dv-native-modal--success');
          modal.querySelector('[data-dv-native-modal-title]').textContent = "You're on the list.";
          modal.querySelector('[data-dv-native-waitlist-form]').hidden = true;
          modal.querySelector('[data-dv-native-waitlist-status]').textContent = 'Check your inbox.';
          modal.querySelector('[data-dv-native-modal-close]').focus();
        } else modal.querySelector('[data-dv-native-waitlist-status]').textContent = 'Waitlist signup is unavailable right now.';
      }).catch(function () { modal.querySelector('[data-dv-native-waitlist-status]').textContent = 'Waitlist signup is unavailable right now.'; });
    });
    input.focus();
  }

  function addItems(detail) {
    if (realMode) {
      Promise.resolve().then(function () { return window.DVRealCommerce.add(detail || {}); }).then(function (result) {
        if (result.waitlist) showWaitlist(result.waitlist);
        else openBag();
      }).catch(function (error) { showModal('Could not add to bag', '<p>' + escapeHTML(error.message) + '</p>'); });
      return;
    }
    var incoming = detail && Array.isArray(detail.items) ? detail.items : detail && detail.item ? [detail.item] : [];
    var clean = splitPairedItems(incoming.map(cleanItem).filter(Boolean));
    var waitlist = clean.find(function (item) { return item.mode === 'waitlist'; });
    if (waitlist) return showWaitlist(waitlist);
    if (!clean.length) return;
    var items = readBag();
    clean.forEach(function (item) {
      var existing = items.find(function (line) { return line.key === item.key; });
      if (existing) existing.quantity = Math.min(99, existing.quantity + item.quantity);
      else items.push(item);
    });
    writeBag(items, { pulse: true });
    openBag();
  }

  function variantItem(variantId) {
    variantId = Number(variantId);
    var found = null;
    products.some(function (product) {
      return Object.keys(product.native || {}).some(function (stone) {
        var native = product.native[stone];
        if (Number(native && native[0]) !== variantId) return false;
        var price = product.silver && product.silver[stone] ? product.silver[stone][0] : Number(native[3]);
        var compareAt = product.silver && product.silver[stone] ? product.silver[stone][1] : Number(native[3]);
        found = cleanItem({
          key: product.id + ':silver:' + stone,
          title: product.name + ' Charm',
          material: 'Sterling Silver',
          stone: stoneLabels[stone] || stone,
          variantId: variantId,
          price: price,
          compareAt: compareAt,
          image: gallery[product.id] && gallery[product.id][stone] && gallery[product.id][stone][0],
          url: '/products/' + native[2]
        });
        return true;
      });
    });
    if (found) return found;
    Object.keys(accessories).some(function (handle) {
      var accessory = accessories[handle];
      if (Number(accessory.native && accessory.native[0]) !== variantId) return false;
      found = cleanItem({
        key: accessory.id,
        title: accessory.name,
        material: 'Sterling Silver',
        variantId: variantId,
        price: accessory.price,
        compareAt: Number(accessory.native[3]),
        image: accessory.image,
        url: '/products/' + handle
      });
      return true;
    });
    return found;
  }

  function variantFromBody(body) {
    try {
      if (body instanceof FormData || body instanceof URLSearchParams) return body.get('id');
      if (typeof body === 'string') {
        var parsed = body.charAt(0) === '{' ? JSON.parse(body) : new URLSearchParams(body);
        if (parsed instanceof URLSearchParams) return parsed.get('id');
        return parsed.id || (parsed.items && parsed.items[0] && parsed.items[0].id);
      }
      if (body && typeof body === 'object') return body.id;
    } catch (_) {}
    return null;
  }

  function quantityFromBody(body) {
    try {
      if (body instanceof FormData || body instanceof URLSearchParams) return body.get('quantity');
      if (typeof body === 'string') {
        var parsed = body.charAt(0) === '{' ? JSON.parse(body) : new URLSearchParams(body);
        if (parsed instanceof URLSearchParams) return parsed.get('quantity');
        return parsed.quantity || (parsed.items && parsed.items[0] && parsed.items[0].quantity);
      }
      if (body && typeof body === 'object') return body.quantity;
    } catch (_) {}
    return 1;
  }

  function interceptAdd(detail) {
    if (detail && detail.stagedPdp) return;
    var variantId = detail && detail.variantId ? detail.variantId : variantFromBody(detail && detail.body);
    var item = variantItem(variantId);
    if (!item) return showModal('Review action blocked', '<p>This unpublished preview stopped a real Shopify cart request. Use the staged material controls to add this selection to the review bag.</p>');
    var now = Date.now();
    if (lastIntercept.key === item.key && now - lastIntercept.time < 700) return;
    lastIntercept = { key: item.key, time: now };
    item.quantity = Math.max(1, Math.min(99, Math.trunc(Number(detail && detail.quantity || quantityFromBody(detail && detail.body)) || 1)));
    addItems({ items: [item] });
  }

  function renderCartPage() {
    if (!/^\/cart\/?$/.test(location.pathname)) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    if (realMode) {
      window.DVRealCommerce.renderPage(main);
      main.onclick = handleBagClick;
      return;
    }
    var items = readBag();
    main.innerHTML = '<section class="dv-native-builder" data-dv-native-cart-page><div class="dv-native-builder__intro"><h1>Your Bag</h1><p>Review your pieces and adjust quantities before checkout.</p></div><div data-dv-native-cart-lines>' + bagContents(items) + '</div>' +
      (items.length ? '<div class="dv-native-bag__footer" style="max-width:560px;margin:24px 0 0 auto"><div class="dv-native-bag__subtotal"><span>Subtotal</span><strong>' + money(subtotal(items)) + '</strong></div><p class="dv-native-bag__shipping">Insured shipping from $12.95, chosen at checkout. Taxes calculated at checkout.</p><button type="button" class="dv-native-bag__button" data-dv-native-checkout>Checkout</button></div>' : '') + '</section>';
    main.onclick = handleBagClick;
  }

  function builderProductImage(product, material, stone) {
    if (material !== 'silver') return goldAssets[product.id] || '';
    return gallery[product.id] && gallery[product.id][stone] && gallery[product.id][stone][0] || '';
  }

  function chainImage(chain) {
    var match = Object.keys(accessories).map(function (key) { return accessories[key]; }).find(function (item) { return item.id === chain.id; });
    return match && (match.detailImage || match.image) || '';
  }

  function builderState() {
    var params = new URLSearchParams(location.search);
    var product = products.find(function (item) { return item.id === params.get('dv_design'); }) || products[0];
    var material = params.get('dv_material') === 'solid' ? 'solid' : 'silver';
    var materialStones = material === 'silver' ? product.stones : ['white'];
    var stone = materialStones.indexOf(params.get('dv_stone')) >= 0 ? params.get('dv_stone') : materialStones[0];
    var availableChains = material === 'silver'
      ? chains.filter(function (item) { return item.id !== 'none'; })
      : chains;
    if (!availableChains.length) availableChains = chains.filter(function (item) { return item.id === 'none'; });
    var chain = availableChains.find(function (item) { return item.id === params.get('dv_chain'); }) || availableChains[0];
    return { product: product, material: material, stone: stone, chain: chain, availableChains: availableChains };
  }

  function materialStoneLabel(product, material, stone) {
    if (material === 'silver') return stoneLabels[stone] || stone;
    return product.id === 'blossom' ? 'Lab-Grown White Diamond + Emerald' : 'Lab-Grown White Diamond';
  }

  function charmPrice(product, material, stone) {
    return material === 'silver' ? Number(product.silver[stone][0]) : Number(product[material]);
  }

  function builderImages(product, material, stone, chain) {
    var images = [];
    if (material === 'silver') {
      var productGallery = gallery[product.id] && gallery[product.id][stone] || [];
      var exactSet = exactSetImages[[product.id, stone, chain.id].join(':')];
      if (exactSet) images.push({ src: exactSet.src, label: 'Selected set · ' + exactSet.label });
      if (productGallery[0]) images.push({ src: productGallery[0], label: 'Charm detail' });
      var selectedChainImage = chainImage(chain);
      if (selectedChainImage) images.push({ src: selectedChainImage, label: chain.name, chainDetail: true });
      if (!exactSet && productGallery[2]) images.push({ src: productGallery[2], label: 'Charm angle' });
    } else {
      var goldImage = builderProductImage(product, material, stone);
      if (goldImage) images.push({ src: goldImage, label: materialLabels[material] + ' charm · Selected chain not pictured' });
    }
    return images;
  }

  function builderInspirationHTML() {
    var cards = Object.keys(exactSetImages).map(function (key) {
      var image = exactSetImages[key];
      return '<figure><img src="' + escapeHTML(image.src) + '" alt="' + escapeHTML(image.label + ' in rhodium-finished sterling silver') + '"><figcaption>' + escapeHTML(image.label) + '</figcaption></figure>';
    }).join('');
    return '<section class="dv-native-builder__inspiration" aria-labelledby="dv-native-builder-inspiration-title"><div><span class="dv-native-review-label">See it together</span><h2 id="dv-native-builder-inspiration-title">Styled as a complete set.</h2><p>Exact pairings shown in rhodium-finished sterling silver.</p></div><div class="dv-native-builder__inspiration-grid">' + cards + '</div></section>';
  }

  function mountBuilder() {
    if (window.DV_ORIGINAL_BUILDER_PREVIEW) return;
    var explicitPage = /^\/pages\/gifting-studio\/?$/i.test(location.pathname) && new URLSearchParams(location.search).get('view') === 'native-builder';
    var marker = document.querySelector('[data-dv-native-builder-mount]');
    if ((!explicitPage && !marker) || !products.length || chains.length < 2) return;
    var main = document.getElementById('MainContent');
    if (!main || main.querySelector('[data-dv-native-builder]')) return;
    if (marker) marker.outerHTML = '<section class="dv-native-builder" data-dv-native-builder></section>';
    else main.innerHTML = '<section class="dv-native-builder" data-dv-native-builder></section><div id="cart-drawer-container"></div>';
    renderBuilder();
  }

  function renderBuilder() {
    var host = document.querySelector('[data-dv-native-builder]');
    if (!host) return;
    var state = builderState();
    var product = state.product;
    var material = state.material;
    var stone = state.stone;
    var chain = state.chain;
    var selectedCharmPrice = charmPrice(product, material, stone);
    var selectedChainPrice = material === 'silver' ? Number(chain.price) : Number(chain.standalonePrice);
    var total = selectedCharmPrice + selectedChainPrice;
    var stones = material === 'silver' ? product.stones : ['white'];
    var materialName = materialLabels[material] || material;
    var selectedStoneName = materialStoneLabel(product, material, stone);
    var materialsHTML = ['silver', 'solid'].map(function (value) {
      var valueStone = value === 'silver' ? product.stones[0] : 'white';
      return '<label class="dv-native-builder__choice"><input type="radio" name="dv_material" value="' + value + '" ' + (value === material ? 'checked' : '') + '><span>' + escapeHTML(materialLabels[value]) + '<small>' + (value === 'silver' ? 'Rhodium-finished .925 silver' : value === 'plated' ? 'Gold-plated .925 sterling silver' : 'Crafted in solid 14K yellow gold') + '</small></span><strong>From ' + money(charmPrice(product, value, valueStone)) + '</strong></label>';
    }).join('');
    var designsHTML = products.map(function (item) {
      var itemStone = material === 'silver' ? item.stones[0] : 'white';
      return '<label class="dv-native-builder__choice"><input type="radio" name="dv_design" value="' + escapeHTML(item.id) + '" ' + (item.id === product.id ? 'checked' : '') + '><span>' + escapeHTML(item.name) + '</span><strong>From ' + money(charmPrice(item, material, itemStone)) + '</strong></label>';
    }).join('');
    var stonesHTML = stones.map(function (value) {
      return '<label class="dv-native-builder__choice"><input type="radio" name="dv_stone" value="' + escapeHTML(value) + '" ' + (value === stone ? 'checked' : '') + '><span>' + escapeHTML(materialStoneLabel(product, material, value)) + '</span><strong>' + money(charmPrice(product, material, value)) + '</strong></label>';
    }).join('');
    var chainsHTML = state.availableChains.map(function (item) {
      var chainDetail = material === 'silver' ? item.note : item.note.replace(/ · \$[\d.]+ with a charm \(save 10%\)/, '');
      var chainPrice = material === 'silver' ? Number(item.price) : Number(item.standalonePrice);
      return '<label class="dv-native-builder__choice"><input type="radio" name="dv_chain" value="' + escapeHTML(item.id) + '" ' + (item.id === chain.id ? 'checked' : '') + '><span>' + escapeHTML(item.name) + '<small>' + escapeHTML(chainDetail) + '</small></span><strong>' + (chainPrice ? '+' + money(chainPrice) : 'Included') + '</strong></label>';
    }).join('');
    var imageHTML = builderImages(product, material, stone, chain).map(function (image, index) {
      return '<figure class="' + (index === 0 ? 'dv-native-builder__lead' : '') + '"><img' + (image.chainDetail ? ' style="object-fit:contain"' : '') + ' src="' + escapeHTML(image.src) + '" alt="' + escapeHTML(product.name + ' · ' + image.label) + '"><figcaption>' + escapeHTML(image.label) + '</figcaption></figure>';
    }).join('');
    var chainIntro = 'Choose a signature charm, stone and chain, then see the complete set come together.';
    var chainNote = material === 'silver' ? '' : '<p class="dv-native-builder__compatibility">Sterling silver chain at full standalone price. Gold charm ships separately from in-stock silver. Made to order · Ships within 2–3 weeks. No gold-chain option; no gold pairing discount.</p>';
    var selectedChainSaving = material === 'silver' && Number(chain.standalonePrice) > Number(chain.price) ? Number(chain.standalonePrice) - Number(chain.price) : 0;
    host.innerHTML = '<div class="dv-native-builder__intro"><span class="dv-native-review-label">Build Your Set</span><h1>Make it yours.</h1><p>' + escapeHTML(chainIntro) + '</p></div><div class="dv-native-builder__grid"><div class="dv-native-builder__preview">' + imageHTML + '</div><div><fieldset><legend>1. Material · ' + escapeHTML(materialName) + '</legend><div class="dv-native-builder__choices">' + materialsHTML + '</div></fieldset><fieldset><legend>2. Design · ' + escapeHTML(product.name) + '</legend><div class="dv-native-builder__choices">' + designsHTML + '</div></fieldset><fieldset><legend>3. Stone · ' + escapeHTML(selectedStoneName) + '</legend><div class="dv-native-builder__choices">' + stonesHTML + '</div></fieldset><fieldset><legend>4. Chain · ' + escapeHTML(chain.name) + '</legend><div class="dv-native-builder__choices">' + chainsHTML + '</div>' + chainNote + '</fieldset><div class="dv-native-builder__total"><span>' + (chain.id === 'none' ? 'Charm total' : 'Set total') + '</span><span>' + money(total) + '</span></div><button type="button" class="dv-native-builder__add" data-dv-native-builder-add>' + (material === 'solid' ? 'Order Yours' : material === 'plated' ? 'Join the waitlist' : 'Add to bag') + '</button><p class="dv-native-builder__note">' + escapeHTML(materialName + ' ' + product.name + ' charm') + ' ' + money(selectedCharmPrice) + (chain.id !== 'none' ? ' + ' + escapeHTML(chain.name) + ' ' + money(selectedChainPrice) + (selectedChainSaving ? ' · Save 10% (' + money(selectedChainSaving) + ')' : '') : '') + '</p></div></div>' + builderInspirationHTML();
    if (realMode && material === 'solid' && !Number(window.DV_GOLD_VARIANTS && window.DV_GOLD_VARIANTS[product.id])) {
      host.querySelector('[data-dv-native-builder-add]').disabled = true;
      console.warn('DIVETIA gold variant missing for ' + product.id + '; Add to Bag disabled.');
    }
    host.onchange = function (event) {
      var input = event.target;
      if (!input.matches('input[type="radio"]')) return;
      var next = new URL(location.href);
      next.searchParams.set(input.name, input.value);
      if (input.name === 'dv_design' || input.name === 'dv_material') next.searchParams.delete('dv_stone');
      if (input.name === 'dv_material') next.searchParams.delete('dv_chain');
      history.pushState({}, '', next);
      renderBuilder();
    };
    host.onclick = function (event) {
      if (!event.target.closest('[data-dv-native-builder-add]')) return;
      if (material === 'solid' && window.DV_SOLID_PREVIEW_LOCKED) return;
      if (material === 'plated') { showWaitlist({ title: product.name + ' Charm', design: product.id, material: materialName,
        price: selectedCharmPrice, image: builderProductImage(product, material, stone) }); return; }
      var accessory = material === 'silver' ? Object.keys(accessories).map(function (key) { return accessories[key]; }).find(function (item) { return item.id === chain.id; }) : null;
      var nativeCharm = material === 'silver' && product.native && product.native[stone];
      addItems({ items: [{
        design: product.id,
        materialKey: material,
        stoneKey: stone,
        chainId: chain.id,
        chainMaterial: chain.material || 'silver',
        key: product.id + ':' + material + ':' + stone + ':' + chain.id,
        title: product.name + ' Charm' + (chain.id === 'none' ? '' : ' + ' + chain.name),
        material: materialName,
        stone: selectedStoneName,
        chain: chain.id === 'none' ? '' : chain.name,
        price: total,
        image: builderProductImage(product, material, stone),
        fulfillment: material === 'solid' ? 'Made for you · Ships within 2–3 weeks' : '',
        components: [
          { role: 'charm', variantId: Number(nativeCharm && nativeCharm[0]) || null, price: selectedCharmPrice },
          { role: 'chain', material: chain.material || (material === 'silver' ? 'silver' : 'plated'), variantId: Number(accessory && accessory.native[0]) || null, price: selectedChainPrice }
        ].filter(function (component) { return component.variantId || component.price; })
      }] });
    };
  }

  window.addEventListener('dv:native:add', function (event) {
    var detail = event.detail || {};
    if (window.DV_SOLID_PREVIEW_LOCKED && detail.items && detail.items.some(function (item) { return item && item.materialKey === 'solid'; })) {
      if (window.console && console.info) console.info('DIVETIA preview: Solid 14K Gold ordering is locked; nothing was sent.');
      return;
    }
    if (detail.realSelection && detail.realSelection.some(function (item) { return item.material !== 'silver' && !(item.role === 'charm' && item.material === 'solid'); })) return;
    if (window.DV_SOLID_PREVIEW_LOCKED && detail.realSelection && detail.realSelection.some(function (item) { return item.material === 'solid'; })) return;
    if (detail.items && detail.items.some(function (item) { return item.mode === 'waitlist' || item.materialKey === 'plated' || /gold[\s-]*plated/i.test(String(item.material || '')); })) return;
    addItems(detail);
  });
  window.addEventListener('dv:native:open-bag', openBag);
  document.addEventListener('click', function (event) {
    if (!realMode) return;
    var trigger = event.target.closest('a[href="/cart"], a[href^="/cart?"], a[data-cart-icon], button[data-cart-icon], a[data-open-cart], button[data-open-cart], a[data-dv-native-open-bag], button[data-dv-native-open-bag]');
    if (!trigger || trigger.closest('[data-dv-native-bag]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openBag();
  }, true);
  window.addEventListener('dv:native:checkout-review', function () {
    if (realMode) window.DVRealCommerce.checkout();
    else openCheckoutReview();
  });
  window.addEventListener('storage', function (event) {
    if (realMode) return;
    if (event.key !== BAG_KEY) return;
    var items = readBag();
    updateCounts(items);
    updateCartIndicators(items, false);
    renderCartPage();
  });
  window.addEventListener('dv:native:blocked', function (event) {
    if (event.detail && (event.detail.kind === 'form-add' || /\/cart\/add/i.test(event.detail.url || ''))) interceptAdd(event.detail);
    else if (event.detail && event.detail.kind === 'form' && event.detail.userInitiated && event.detail.visibleForm && !document.querySelector('[data-dv-native-modal]:not([hidden]), [data-dv-native-bag]:not([hidden])')) showModal('Review action blocked', '<p>This unpublished preview did not submit or store the form.</p>');
  });
  window.addEventListener('popstate', function () { if (document.querySelector('[data-dv-native-builder]')) renderBuilder(); });
  document.addEventListener('keydown', function (event) {
    var visible = document.querySelector('[data-dv-native-bag]:not([hidden]) .dv-native-bag__panel, [data-dv-native-modal]:not([hidden]) .dv-native-modal__card');
    if (event.key === 'Escape') {
      closeBag();
      var modal = document.querySelector('[data-dv-native-modal]');
      if (modal) {
        modal.querySelectorAll('input[type="email"]').forEach(function (input) { input.value = ''; });
        modal.hidden = true;
      }
      document.documentElement.classList.remove('dv-native-bag-open');
      if (focusReturn && focusReturn.focus) focusReturn.focus();
      return;
    }
    if (event.key !== 'Tab' || !visible) return;
    var focusable = Array.prototype.slice.call(visible.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  function init() {
    mountBag();
    mountCartIndicators();
    renderBag();
    renderCartPage();
    mountBuilder();
    if (realMode) window.DVRealCommerce.refresh().catch(function (error) { console.warn('DIVETIA cart could not load:', error.message); });
  }

  window.addEventListener('dv:native:real-cart-updated', function () {
    renderBag();
    renderCartPage();
  });
  document.addEventListener('visibilitychange', function () {
    if (realMode && !document.hidden) window.DVRealCommerce.refresh().catch(function () {});
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}());
